import { render } from "./ApprovalsListCardDate.vue?vue&type=template&id=890178fc"
import script from "./ApprovalsListCardDate.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__